import React, { forwardRef } from 'react';
import type { ComponentPropsWithoutRef, ElementType } from 'react';
import styled from '@emotion/styled';
import { Stack } from './Stack';
import { convertOldVStackProps } from './converter.old';
import type { OldVStackProps } from './converter.old';

export type { HorizontalAlignment } from './converter.old';
export type VStackProps = OldVStackProps;
type VStackComponentProps = VStackProps & ComponentPropsWithoutRef<'div'> & { as?: ElementType };

/** @deprecated Stack을 사용해주세요. */
const VStackBase = forwardRef<HTMLDivElement, VStackComponentProps>((props, ref) => (
  <Stack {...convertOldVStackProps(props)} ref={ref} />
));

VStackBase.displayName = 'VStackBase';

export const VStack = styled(VStackBase)``;

VStack.displayName = 'VStack';
